import { connectBaseApi, routeClient, createRpcMutation, createRpcQuery } from "@racoon/api";
import { PAST_DAY_CACHE_S } from "../cache";

export const routeGrpc = connectBaseApi
  .enhanceEndpoints({ addTagTypes: ["Routes", "Route"] })
  .injectEndpoints({
    endpoints: (build) => ({
      createRouteWithJobs: createRpcMutation(build, routeClient, "createRouteWithJobs", {
        invalidatesTags: ["Routes", "Order"],
      }),
      // May open a new shift for the truck, so the shift lists go stale too.
      createRoutesFromStops: createRpcMutation(build, routeClient, "createRoutesFromStops", {
        invalidatesTags: ["Routes", "Order", { type: "DriverOnShift", id: "LIST" }],
      }),
      createPseudoRoute: createRpcMutation(build, routeClient, "createPseudoRoute", {
        invalidatesTags: ["Routes", "Order"],
      }),
      updateRouteWithJobs: createRpcMutation(build, routeClient, "updateRouteWithJobs", {
        invalidatesTags: ["Routes", "Order"],
      }),
      forceCompleteRoute: createRpcMutation(build, routeClient, "forceCompleteRoute", {
        invalidatesTags: (result, error, arg) => ["Routes", { type: "Route", id: String(arg.id) }],
      }),
      approveRoute: createRpcMutation(build, routeClient, "approveRoute", {
        invalidatesTags: ["Routes"],
      }),
      cancelRoute: createRpcMutation(build, routeClient, "cancelRoute", {
        invalidatesTags: (result, error, arg) => ["Routes", { type: "Route", id: String(arg.id) }],
      }),
      listRoutes: createRpcQuery(build, routeClient, "listRoutes", {
        providesTags: ["Routes"],
      }),
      listRoutesPastDay: createRpcQuery(build, routeClient, "listRoutes", {
        providesTags: ["Routes"],
        keepUnusedDataFor: PAST_DAY_CACHE_S,
      }),
      listActiveTrucksWithRoutes: createRpcQuery(build, routeClient, "listActiveTrucksWithRoutes", {
        providesTags: ["Routes"],
      }),
      getRoute: createRpcQuery(build, routeClient, "getRoute", {
        providesTags: (result, error, arg) => [{ type: "Route", id: String(arg.id) }],
      }),
      moveJobsBetweenRoutes: createRpcMutation(build, routeClient, "moveJobsBetweenRoutes", {
        invalidatesTags: ["Routes"],
      }),
      // A moved route leaves one shift's lists for another's, so both the route
      // caches and the shift lists go stale. Defined once: a second injection of
      // the same name is silently dropped, and its tags with it.
      changeRouteDriverOnShift: createRpcMutation(build, routeClient, "changeRouteDriverOnShift", {
        invalidatesTags: (result, error, arg) => [
          "Routes",
          { type: "Route", id: String(arg.routeId) },
          { type: "DriverOnShift", id: "LIST" },
        ],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useCreateRouteWithJobsMutation,
  useCreateRoutesFromStopsMutation,
  useCreatePseudoRouteMutation,
  useUpdateRouteWithJobsMutation,
  useForceCompleteRouteMutation,
  useApproveRouteMutation,
  useCancelRouteMutation,
  useListRoutesQuery,
  useListRoutesPastDayQuery,
  useLazyListRoutesQuery,
  useGetRouteQuery,
  useLazyGetRouteQuery,
  useMoveJobsBetweenRoutesMutation,
  useChangeRouteDriverOnShiftMutation,
  useLazyListActiveTrucksWithRoutesQuery,
} = routeGrpc;
